import React from "react";
import { MuellerThemeContext, MuellerThemeProviderValue } from "components/Shared/MuellerThemeProvider";
import { useContext } from "react";
import { Box } from "@mui/material";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";

const ThemeSelection = () => {
  const themeContext = useContext<MuellerThemeProviderValue>(MuellerThemeContext);

  return (
    <Box>
      <RadioGroup
        name="theme"
        value={themeContext.currentTheme.code}
        onChange={e => themeContext.changeTheme(e.target.value)}>
          {themeContext.themeOptions.map(t => (
            <FormControlLabel 
              key={t.code}
              value={t.code} 
              control={<Radio />} 
              label={<><i className="material-icons" style={{ paddingRight: 'var(--padding-10px)' }}>{t.iconName}</i><span>{t.displayName}</span></>}
            />
          ))}
      </RadioGroup>
    </Box>
  );
};

export default ThemeSelection;
